<template>
  <section id="gameSection" class="game-pay-section">
    <div id="animated_div">
      <b-container>
      <b-row class="align-content-center">
        <b-col sm="12" md="4" lg="4">
          <div class="game-play-img-container">
            <img class="ufo-img" src="../../assets/img/game-play-img.png" alt="Game play image">
            <img class="asteroid-img" src="../../assets/img/asteroid.png" alt="Asteroid image">
          </div>
        </b-col>
        <b-col sm="12" md="8" lg="8">
          <div class="game-play-content">
           <div class="title-img-container">
            <img src="../../assets/img/gamepley-title.svg" alt="Game play title image">
           </div>
            <div class="video-container">
                <video :src="videoUrl" controls poster="@/assets/img/poster-video.jpg" width="100%">
                  Your browser does not support the video tag.
                </video>
            </div>
           <p class="gameplay-text">{{$t('gameplay_text')}}</p>
           <p class="gameplay-text">{{$t('gameplay_text_1')}}</p>
           <img class="planet-img" src="../../assets/img/planet.png" alt="Planet image">
          </div>
        </b-col>
      </b-row>
    </b-container>
    </div>
    <img class="space-do-img" src="../../assets/img/robot-dog.png" alt="Space dog image">
  </section>
</template>

<script>
export default {
  data () {
    return {
      videoUrl: require('@/assets/video/back-to-the-star.mp4')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/app.scss";
  .game-pay-section{
    background: url('../../assets/img/bg-gameplay.svg') no-repeat;
    background-size: cover;
    position: relative;
    @media screen and (min-width: 320px) {
      height: auto;
      min-height: 900px;
    }
    @media screen and (min-width: 768px) {
        min-height: 550px;
    }
    @media screen and (min-width: 1440px) {
      min-height: 1200px;
    }
    @media screen and (min-width: 1920px) {
    }
    .game-play-img-container{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      height: 100%;
      .ufo-img{
        animation: ufoAnimation 4s linear infinite alternate;
        @media screen and (min-width: 320px) {
          max-width: 375px;
          width: 100%;
        }
        @media screen and (min-width: 768px) {
          width: 490px;
          height: auto;
          position: absolute;
          left: -70px;
          top: 0;
          max-width: unset;
        }
        @media screen and (min-width: 1440px) {
          max-width: 800px;
          width: auto;
          position: absolute;
          right: -260px;
          left: unset;
          top: 0;
        }
        @media screen and (min-width: 1920px) {
        }
      }
      .asteroid-img {
        width: 100%;
        animation: asteroidAnimation 2s linear infinite alternate;
        @media screen and (min-width: 320px) {
          display: none;
        }
        @media screen and (min-width: 768px) {
          display:block;
          max-width: 32px;
          position: absolute;
          bottom: 0;
          left: -60%;
         transform: translateX(calc(-50% - 315px));
        }
        @media screen and (min-width: 1440px) {
          max-width: 80px;
          bottom: 0;
        }
        @media screen and (min-width: 1920px) {
        }
      }
    }
    .game-play-content{
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 80px;
      position: relative;
      @media screen and (min-width: 320px) {
        padding-top: 34px;
        gap: 24px;
      }
      @media screen and (min-width: 768px) {
        padding-top: 0;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
      .title-img-container{
        position: relative;
        img{
          position: relative;
          left: -8px;
          width: 100%;
          max-width: 700px;
          height: auto;
        @media screen and (min-width: 320px) {
          max-width: 287px;
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 1440px) {
          max-width: 700px;
        }
        @media screen and (min-width: 1920px) {
        }
        }
      }
      .gameplay-text{
        color: #FFFF9F;
        font-family: $main-font;
        font-style: normal;
        font-weight: 600;
        margin: 0;
        @media screen and (min-width: 320px) {
          font-size: 16px;
          line-height: 24px;
        }
        @media screen and (min-width: 768px) {
          font-size: 16px;
          line-height: 36px;
        }
        @media screen and (min-width: 1440px) {
          font-size: 20px;
          line-height: 30px;
        }
        @media screen and (min-width: 1920px) {
        }
      }
      .planet-img{
        width: 100%;
        max-width: 140px;
        animation: asteroidAnimation 2s linear infinite alternate;
        @media screen and (min-width: 320px) {
          max-width: 70px;
          position: absolute;
          top: 0;
          right: 0;
        }
        @media screen and (min-width: 768px) {
          max-width: 80px;
          position: absolute;
          top: calc(50% + 90px);
          right: 0;
        }
        @media screen and (min-width: 1440px) {
          max-width: 140px;
          top: calc(50% + 90px);
          right: -140px;
        }
        @media screen and (min-width: 1920px) {
        }
      }
    }
    .space-do-img {
      width: 100%;
      max-width: 360px;
      height: auto;
      position: absolute;
      animation: ufoAnimation 4s linear infinite alternate;
      @media screen and (min-width: 320px) {
        max-width: 133px;
        right: 15px;
        bottom: 55px;
      }
      @media screen and (min-width: 768px) {
        bottom: -30px;
        left: 20%;
        transform: translateX(calc(20% + 150px));
      }
      @media screen and (min-width: 1440px) {
         max-width: 360px;
         left: 16%;
      }
      @media screen and (min-width: 1920px) {
        left: 21%;
      }
    }
    .video-container {
      position: relative;
      width: 100%;
      padding-bottom: 56.25%; /* 16:9 аспектне відношення */
      padding-top: 30px;
      height: 0;
      overflow: hidden;
      @media screen and (min-width: 320px) {
        display:none;
          max-width: 325px;
      }
      @media screen and (min-width: 768px) {
        display:flex;
        max-width: 490px;
        padding-top: 90px;
        padding-bottom: 32.25%;
      }
      @media screen and (min-width: 1440px) {
        max-width: unset;
        padding-top: 0;
        padding-bottom: 56.25%; /* 16:9 аспектне відношення */
        box-shadow: -1px 0px 87px 10px rgba(45,23,74,1);
      }
      @media screen and (min-width: 1920px) {
      }
      video {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        @media screen and (min-width: 320px) {
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 1440px) {
        }
        @media screen and (min-width: 1920px) {
        }
      }
    }
  }

#animated_div{
  width: 100%;
  height: 100%;
  background: url('../../assets/img/star.png') repeat-x;
  background-size:cover;
  -webkit-animation: animatebackground 60s linear infinite;
  animation: animatebackground 60s linear infinite;
  -ms-animation: animatebackground 60s linear infinite;
  -moz-animation: animatebackground 60s linear infinite;
    @media screen and (min-width: 320px) {
      min-height: 900px;
    }
    @media screen and (min-width: 768px) {
        min-height: 900px;
    }
    @media screen and (min-width: 1440px) {
      min-height: 1260px;
    }
    @media screen and (min-width: 1920px) {
    }
}
@keyframes animatebackground
{
 from {background-position: 0 0;}
 to {background-position: -1000px 0;}
}

@-webkit-keyframes animatebackground
{
 from {background-position: 0 0;}
 to {background-position: -1000px 0;}
}

@-ms-keyframes animatebackground
{
 from {background-position: 0 0;}
 to {background-position: -1000px 0;}
}

@-moz-keyframes animatebackground
{
 from {background-position: 0 0;}
 to {background-position: -1000px 0;}
}
@keyframes ufoAnimation {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(20px); /* Встановіть величину руху вниз */
  }
}
@keyframes asteroidAnimation {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(20px);
  }
}
</style>
